// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/rotate-ccw.js';

import { paths } from '../generated/rotate-ccw';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('rotate-ccw', Original, paths);
